var items = {
  "block.minecraft.air": "õhk",
  "block.minecraft.stone": "kivi",
  "block.minecraft.granite": "graniit",
  "block.minecraft.polished_granite": "lihvitud graniit",
  "block.minecraft.diorite": "dioriit",
  "block.minecraft.polished_diorite": "lihvitud dioriit",
  "block.minecraft.andesite": "andesiit",
  "block.minecraft.polished_andesite": "lihvitud andesiit",
  "block.minecraft.grass_block": "muruplokk",
  "block.minecraft.dirt": "muld",
  "block.minecraft.coarse_dirt": "jäme muld",
  "block.minecraft.podzol": "leedemuld",
  "block.minecraft.crimson_nylium": "karmiinpunane netseel",
  "block.minecraft.warped_nylium": "kentsakas netseel",
  "block.minecraft.cobblestone": "munakivi",
  "block.minecraft.oak_planks": "tammelauad",
  "block.minecraft.spruce_planks": "kuuselauad",
  "block.minecraft.birch_planks": "kaselauad",
  "block.minecraft.jungle_planks": "džunglipuidust lauad",
  "block.minecraft.acacia_planks": "akaatsialauad",
  "block.minecraft.dark_oak_planks": "tumeda tamme lauad",
  "block.minecraft.crimson_planks": "karmiinpunased lauad",
  "block.minecraft.warped_planks": "kentsakad lauad",
  "block.minecraft.oak_sapling": "tammeistik",
  "block.minecraft.spruce_sapling": "kuuseistik",
  "block.minecraft.birch_sapling": "kaseistik",
  "block.minecraft.jungle_sapling": "džunglipuu istik",
  "block.minecraft.acacia_sapling": "akaatsiaistik",
  "block.minecraft.dark_oak_sapling": "tumeda tamme istik",
  "block.minecraft.bedrock": "aluskivi",
  "block.minecraft.sand": "liiv",
  "block.minecraft.red_sand": "punane liiv",
  "block.minecraft.gravel": "kruus",
  "block.minecraft.gold_ore": "kullamaak",
  "block.minecraft.iron_ore": "rauamaak",
  "block.minecraft.coal_ore": "söemaak",
  "block.minecraft.nether_gold_ore": "netheri kullamaak",
  "block.minecraft.oak_log": "tammetüvi",
  "block.minecraft.spruce_log": "kuusetüvi",
  "block.minecraft.birch_log": "kasetüvi",
  "block.minecraft.jungle_log": "džunglipuu tüvi",
  "block.minecraft.acacia_log": "akaatsiatüvi",
  "block.minecraft.dark_oak_log": "tumeda tamme tüvi",
  "block.minecraft.crimson_stem": "karmiinpunane vars",
  "block.minecraft.warped_stem": "kentsakas vars",
  "block.minecraft.stripped_oak_log": "kooritud tammetüvi",
  "block.minecraft.stripped_spruce_log": "kooritud kuusetüvi",
  "block.minecraft.stripped_birch_log": "kooritud kasetüvi",
  "block.minecraft.stripped_jungle_log": "kooritud džunglipuu tüvi",
  "block.minecraft.stripped_acacia_log": "kooritud akaatsiatüvi",
  "block.minecraft.stripped_dark_oak_log": "kooritud tumeda tamme tüvi",
  "block.minecraft.stripped_crimson_stem": "kooritud karmiinpunane vars",
  "block.minecraft.stripped_warped_stem": "kooritud kentsakas vars",
  "block.minecraft.stripped_oak_wood": "kooritud tammepuit",
  "block.minecraft.stripped_spruce_wood": "kooritud kuusepuit",
  "block.minecraft.stripped_birch_wood": "kooritud kasepuit",
  "block.minecraft.stripped_jungle_wood": "kooritud džunglipuit",
  "block.minecraft.stripped_acacia_wood": "kooritud akaatsiapuit",
  "block.minecraft.stripped_dark_oak_wood": "kooritud tumeda tamme puit",
  "block.minecraft.stripped_crimson_hyphae": "kooritud karmiinpunased hüüfid",
  "block.minecraft.stripped_warped_hyphae": "kooritud kentsakad hüüfid",
  "block.minecraft.oak_wood": "tammepuit",
  "block.minecraft.spruce_wood": "kuusepuit",
  "block.minecraft.birch_wood": "kasepuit",
  "block.minecraft.jungle_wood": "džunglipuit",
  "block.minecraft.acacia_wood": "akaatsiapuit",
  "block.minecraft.dark_oak_wood": "tumeda tamme puit",
  "block.minecraft.crimson_hyphae": "karmiinpunased hüüfid",
  "block.minecraft.warped_hyphae": "kentsakad hüüfid",
  "block.minecraft.oak_leaves": "tammelehed",
  "block.minecraft.spruce_leaves": "kuuselehed",
  "block.minecraft.birch_leaves": "kaselehed",
  "block.minecraft.jungle_leaves": "džunglipuu lehed",
  "block.minecraft.acacia_leaves": "akaatsialehed",
  "block.minecraft.dark_oak_leaves": "tumeda tamme lehed",
  "block.minecraft.sponge": "käsn",
  "block.minecraft.wet_sponge": "märg käsn",
  "block.minecraft.glass": "klaas",
  "block.minecraft.lapis_ore": "lasuriidimaak",
  "block.minecraft.lapis_block": "lasuriidiplokk",
  "block.minecraft.dispenser": "jaotur",
  "block.minecraft.sandstone": "liivakivi",
  "block.minecraft.chiseled_sandstone": "peiteldatud liivakivi",
  "block.minecraft.cut_sandstone": "lõigatud liivakivi",
  "block.minecraft.note_block": "noodiplokk",
  "block.minecraft.powered_rail": "jõurööpad",
  "block.minecraft.detector_rail": "andurrööpad",
  "block.minecraft.sticky_piston": "kleepuv kolb",
  "block.minecraft.cobweb": "ämblikuvõrk",
  "block.minecraft.grass": "muru",
  "block.minecraft.fern": "sõnajalg",
  "block.minecraft.dead_bush": "surnud põõsas",
  "block.minecraft.seagrass": "mererohi",
  "block.minecraft.sea_pickle": "merikurk",
  "block.minecraft.piston": "kolb",
  "block.minecraft.white_wool": "valge vill",
  "block.minecraft.orange_wool": "oranž vill",
  "block.minecraft.magenta_wool": "fuksiinpunane vill",
  "block.minecraft.light_blue_wool": "helesinine vill",
  "block.minecraft.yellow_wool": "kollane vill",
  "block.minecraft.lime_wool": "laimiroheline vill",
  "block.minecraft.pink_wool": "roosa vill",
  "block.minecraft.gray_wool": "hall vill",
  "block.minecraft.light_gray_wool": "helehall vill",
  "block.minecraft.cyan_wool": "tsüaansinine vill",
  "block.minecraft.purple_wool": "lilla vill",
  "block.minecraft.blue_wool": "sinine vill",
  "block.minecraft.brown_wool": "pruun vill",
  "block.minecraft.green_wool": "roheline vill",
  "block.minecraft.red_wool": "punane vill",
  "block.minecraft.black_wool": "must vill",
  "block.minecraft.dandelion": "võilill",
  "block.minecraft.poppy": "magun",
  "block.minecraft.blue_orchid": "sinine orhidee",
  "block.minecraft.allium": "lauk",
  "block.minecraft.azure_bluet": "sinine inglisilm",
  "block.minecraft.red_tulip": "punane tulp",
  "block.minecraft.orange_tulip": "oranž tulp",
  "block.minecraft.white_tulip": "valge tulp",
  "block.minecraft.pink_tulip": "roosa tulp",
  "block.minecraft.oxeye_daisy": "harilik härjasilm",
  "block.minecraft.cornflower": "rukkilill",
  "block.minecraft.lily_of_the_valley": "maikelluke",
  "block.minecraft.wither_rose": "witheriroos",
  "block.minecraft.brown_mushroom": "pruun seen",
  "block.minecraft.red_mushroom": "punane seen",
  "block.minecraft.crimson_fungus": "karmiinpunane seen",
  "block.minecraft.warped_fungus": "kentsakas seen",
  "block.minecraft.crimson_roots": "karmiinpunased juured",
  "block.minecraft.warped_roots": "kentsakad juured",
  "block.minecraft.nether_sprouts": "nether-võrsed",
  "block.minecraft.weeping_vines": "nutvad väädid",
  "block.minecraft.twisting_vines": "väänduvad väädid",
  "block.minecraft.sugar_cane": "suhkruroog",
  "block.minecraft.kelp": "vetikas",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "kullaplokk",
  "block.minecraft.iron_block": "rauaplokk",
  "block.minecraft.oak_slab": "tammeplaat",
  "block.minecraft.spruce_slab": "kuuseplaat",
  "block.minecraft.birch_slab": "kaseplaat",
  "block.minecraft.jungle_slab": "džunglipuidust plaat",
  "block.minecraft.acacia_slab": "akaatsiaplaat",
  "block.minecraft.dark_oak_slab": "tumeda tamme plaat",
  "block.minecraft.crimson_slab": "karmiinpunane plaat",
  "block.minecraft.warped_slab": "kentsakas plaat",
  "block.minecraft.stone_slab": "kiviplaat",
  "block.minecraft.smooth_stone_slab": "siledast kivist plaat",
  "block.minecraft.sandstone_slab": "liivakiviplaat",
  "block.minecraft.cut_sandstone_slab": "lõigatud liivakivist plaat",
  "block.minecraft.petrified_oak_slab": "kivistunud tammeplaat",
  "block.minecraft.cobblestone_slab": "munakiviplaat",
  "block.minecraft.brick_slab": "tellisplaat",
  "block.minecraft.stone_brick_slab": "kivitellisplaat",
  "block.minecraft.nether_brick_slab": "nether-tellisplaat",
  "block.minecraft.quartz_slab": "kvartsplaat",
  "block.minecraft.red_sandstone_slab": "punane liivakiviplaat",
  "block.minecraft.cut_red_sandstone_slab": "lõigatud punasest liivakivist plaat",
  "block.minecraft.purpur_slab": "purpurplaat",
  "block.minecraft.prismarine_slab": "prismariiniplaat",
  "block.minecraft.prismarine_brick_slab": "prismariinitellistest plaat",
  "block.minecraft.dark_prismarine_slab": "tumedast prismariinist plaat",
  "block.minecraft.smooth_quartz": "siledast kvartsist plokk",
  "block.minecraft.smooth_red_sandstone": "sile punane liivakivi",
  "block.minecraft.smooth_sandstone": "sile liivakivi",
  "block.minecraft.smooth_stone": "sile kivi",
  "block.minecraft.bricks": "tellised",
  "block.minecraft.tnt": "dünamiit",
  "block.minecraft.bookshelf": "raamaturiiul",
  "block.minecraft.mossy_cobblestone": "sammaldunud munakivi",
  "block.minecraft.obsidian": "obsidiaan",
  "block.minecraft.torch": "tõrvik",
  "block.minecraft.end_rod": "endivarras",
  "block.minecraft.chorus_plant": "kooritaim",
  "block.minecraft.chorus_flower": "koorilill",
  "block.minecraft.purpur_block": "purpurplokk",
  "block.minecraft.purpur_pillar": "purpursammas",
  "block.minecraft.purpur_stairs": "purpurtrepp",
  "block.minecraft.spawner": "tekitaja",
  "block.minecraft.oak_stairs": "tammetrepp",
  "block.minecraft.chest": "kirst",
  "block.minecraft.diamond_ore": "teemantmaak",
  "block.minecraft.diamond_block": "teemantplokk",
  "block.minecraft.crafting_table": "meisterduslaud",
  "block.minecraft.farmland": "põllumaa",
  "block.minecraft.furnace": "ahi",
  "block.minecraft.ladder": "redel",
  "block.minecraft.rail": "rööpad",
  "block.minecraft.cobblestone_stairs": "munakivitrepp",
  "block.minecraft.lever": "kang",
  "block.minecraft.stone_pressure_plate": "kivist surveplaat",
  "block.minecraft.oak_pressure_plate": "tammest surveplaat",
  "block.minecraft.spruce_pressure_plate": "kuusest surveplaat",
  "block.minecraft.birch_pressure_plate": "kasest surveplaat",
  "block.minecraft.jungle_pressure_plate": "džunglipuidust surveplaat",
  "block.minecraft.acacia_pressure_plate": "akaatsiast surveplaat",
  "block.minecraft.dark_oak_pressure_plate": "tumedast tammest surveplaat",
  "block.minecraft.crimson_pressure_plate": "karmiinpunane surveplaat",
  "block.minecraft.warped_pressure_plate": "kentsakas surveplaat",
  "block.minecraft.polished_blackstone_pressure_plate": "lihvitud mustkivist surveplaat",
  "block.minecraft.redstone_ore": "redstone-maak",
  "block.minecraft.redstone_torch": "redstone-tõrvik",
  "block.minecraft.snow": "lumi",
  "block.minecraft.ice": "jää",
  "block.minecraft.snow_block": "lumeplokk",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "savi",
  "block.minecraft.jukebox": "plaadimängija",
  "block.minecraft.oak_fence": "tammest aed",
  "block.minecraft.spruce_fence": "kuusest aed",
  "block.minecraft.birch_fence": "kasest aed",
  "block.minecraft.jungle_fence": "džunglipuidust aed",
  "block.minecraft.acacia_fence": "akaatsiast aed",
  "block.minecraft.dark_oak_fence": "tumedast tammest aed",
  "block.minecraft.crimson_fence": "karmiinpunane aed",
  "block.minecraft.warped_fence": "kentsakas aed",
  "block.minecraft.pumpkin": "kõrvits",
  "block.minecraft.carved_pumpkin": "nikerdatud kõrvits",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "hingeliiv",
  "block.minecraft.soul_soil": "hingepinnas",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "lihvitud basalt",
  "block.minecraft.soul_torch": "hingetõrvik",
  "block.minecraft.glowstone": "hõõgkivi",
  "block.minecraft.jack_o_lantern": "kõrvitsalatern",
  "block.minecraft.oak_trapdoor": "tammeluuk",
  "block.minecraft.spruce_trapdoor": "kuuseluuk",
  "block.minecraft.birch_trapdoor": "kaseluuk",
  "block.minecraft.jungle_trapdoor": "džunglipuidust luuk",
  "block.minecraft.acacia_trapdoor": "akaatsialuuk",
  "block.minecraft.dark_oak_trapdoor": "tumedast tammest luuk",
  "block.minecraft.crimson_trapdoor": "karmiinpunane luuk",
  "block.minecraft.warped_trapdoor": "kentsakas luuk",
  "block.minecraft.infested_stone": "parasiitne kivi",
  "block.minecraft.infested_cobblestone": "parasiitne munakivi",
  "block.minecraft.infested_stone_bricks": "parasiitsed kivitellised",
  "block.minecraft.infested_mossy_stone_bricks": "parasiitsed sammaldunud kivitellised",
  "block.minecraft.infested_cracked_stone_bricks": "parasiitsed pragunenud kivitellised",
  "block.minecraft.infested_chiseled_stone_bricks": "parasiitsed peiteldatud kivitellised",
  "block.minecraft.stone_bricks": "kivitellised",
  "block.minecraft.mossy_stone_bricks": "sammaldunud kivitellised",
  "block.minecraft.cracked_stone_bricks": "pragunenud kivitellised",
  "block.minecraft.chiseled_stone_bricks": "peiteldatud kivitellised",
  "block.minecraft.brown_mushroom_block": "pruun seeneplokk",
  "block.minecraft.red_mushroom_block": "punane seeneplokk",
  "block.minecraft.mushroom_stem": "seenejalg",
  "block.minecraft.iron_bars": "raudtrellid",
  "block.minecraft.chain": "kett",
  "block.minecraft.glass_pane": "klaaspaneel",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "väädid",
  "block.minecraft.oak_fence_gate": "tammest aiavärav",
  "block.minecraft.spruce_fence_gate": "kuusest aiavärav",
  "block.minecraft.birch_fence_gate": "kasest aiavärav",
  "block.minecraft.jungle_fence_gate": "džunglipuidust aiavärav",
  "block.minecraft.acacia_fence_gate": "akaatsiast aiavärav",
  "block.minecraft.dark_oak_fence_gate": "tumedast tammest aiavärav",
  "block.minecraft.crimson_fence_gate": "karmiinpunane aiavärav",
  "block.minecraft.warped_fence_gate": "kentsakas aiavärav",
  "block.minecraft.brick_stairs": "tellistrepp",
  "block.minecraft.stone_brick_stairs": "kivitellistrepp",
  "block.minecraft.mycelium": "mütseel",
  "block.minecraft.lily_pad": "vesiroosileht",
  "block.minecraft.nether_bricks": "nether-tellised",
  "block.minecraft.cracked_nether_bricks": "pragunenud nether-tellised",
  "block.minecraft.chiseled_nether_bricks": "peiteldatud nether-tellised",
  "block.minecraft.nether_brick_fence": "nether-tellistest aed",
  "block.minecraft.nether_brick_stairs": "nether-tellistrepp",
  "block.minecraft.enchanting_table": "loitsimislaud",
  "block.minecraft.end_portal_frame": "endi portaali raam",
  "block.minecraft.end_stone": "endikivi",
  "block.minecraft.end_stone_bricks": "endikivist tellised",
  "block.minecraft.dragon_egg": "draakonimuna",
  "block.minecraft.redstone_lamp": "redstone-lamp",
  "block.minecraft.sandstone_stairs": "liivakivitrepp",
  "block.minecraft.emerald_ore": "smaragdimaak",
  "block.minecraft.ender_chest": "enderikirst",
  "block.minecraft.tripwire_hook": "traadilõksu konks",
  "block.minecraft.emerald_block": "smaragdiplokk",
  "block.minecraft.spruce_stairs": "kuusetrepp",
  "block.minecraft.birch_stairs": "kasetrepp",
  "block.minecraft.jungle_stairs": "džunglipuidust trepp",
  "block.minecraft.crimson_stairs": "karmiinpunane trepp",
  "block.minecraft.warped_stairs": "kentsakas trepp",
  "block.minecraft.command_block": "käsuplokk",
  "block.minecraft.beacon": "majakas",
  "block.minecraft.cobblestone_wall": "munakivimüür",
  "block.minecraft.mossy_cobblestone_wall": "sammaldunud munakivimüür",
  "block.minecraft.brick_wall": "tellismüür",
  "block.minecraft.prismarine_wall": "prismariinimüür",
  "block.minecraft.red_sandstone_wall": "punasest liivakivist müür",
  "block.minecraft.mossy_stone_brick_wall": "sammaldunud kivitellistest müür",
  "block.minecraft.granite_wall": "graniitmüür",
  "block.minecraft.stone_brick_wall": "kivitellistest müür",
  "block.minecraft.nether_brick_wall": "nether-tellistest müür",
  "block.minecraft.andesite_wall": "andesiitmüür",
  "block.minecraft.red_nether_brick_wall": "punastest nether-tellistest müür",
  "block.minecraft.sandstone_wall": "liivakivimüür",
  "block.minecraft.end_stone_brick_wall": "endikivi tellistest müür",
  "block.minecraft.diorite_wall": "dioriitmüür",
  "block.minecraft.blackstone_wall": "mustkivimüür",
  "block.minecraft.polished_blackstone_wall": "lihvitud mustkivist müür",
  "block.minecraft.polished_blackstone_brick_wall": "lihvitud mustkivi tellistest müür",
  "block.minecraft.stone_button": "kivinupp",
  "block.minecraft.oak_button": "tammenupp",
  "block.minecraft.spruce_button": "kuusenupp",
  "block.minecraft.birch_button": "kasenupp",
  "block.minecraft.jungle_button": "džunglipuidust nupp",
  "block.minecraft.acacia_button": "akaatsianupp",
  "block.minecraft.dark_oak_button": "tumedast tammest nupp",
  "block.minecraft.crimson_button": "karmiinpunane nupp",
  "block.minecraft.warped_button": "kentsakas nupp",
  "block.minecraft.polished_blackstone_button": "lihvitud mustkivist nupp",
  "block.minecraft.anvil": "alasi",
  "block.minecraft.chipped_anvil": "täkkega alasi",
  "block.minecraft.damaged_anvil": "kahjustunud alasi",
  "block.minecraft.trapped_chest": "püüniskirst",
  "block.minecraft.light_weighted_pressure_plate": "kergekaaluline surveplaat",
  "block.minecraft.heavy_weighted_pressure_plate": "raskekaaluline surveplaat",
  "block.minecraft.daylight_detector": "päevavalguse andur",
  "block.minecraft.redstone_block": "redstone-plokk",
  "block.minecraft.nether_quartz_ore": "netheri kvartsmaak",
  "block.minecraft.hopper": "püüdja",
  "block.minecraft.chiseled_quartz_block": "peiteldatud kvartsplokk",
  "block.minecraft.quartz_block": "kvartsplokk",
  "block.minecraft.quartz_bricks": "kvartstellised",
  "block.minecraft.quartz_pillar": "kvartssammas",
  "block.minecraft.quartz_stairs": "kvartstrepp",
  "block.minecraft.activator_rail": "käivitusrööpad",
  "block.minecraft.dropper": "heitja",
  "block.minecraft.white_terracotta": "valge terrakota",
  "block.minecraft.orange_terracotta": "oranž terrakota",
  "block.minecraft.magenta_terracotta": "fuksiinpunane terrakota",
  "block.minecraft.light_blue_terracotta": "helesinine terrakota",
  "block.minecraft.yellow_terracotta": "kollane terrakota",
  "block.minecraft.lime_terracotta": "laimiroheline terrakota",
  "block.minecraft.pink_terracotta": "roosa terrakota",
  "block.minecraft.gray_terracotta": "hall terrakota",
  "block.minecraft.light_gray_terracotta": "helehall terrakota",
  "block.minecraft.cyan_terracotta": "tsüaansinine terrakota",
  "block.minecraft.purple_terracotta": "lilla terrakota",
  "block.minecraft.blue_terracotta": "sinine terrakota",
  "block.minecraft.brown_terracotta": "pruun terrakota",
  "block.minecraft.green_terracotta": "roheline terrakota",
  "block.minecraft.red_terracotta": "punane terrakota",
  "block.minecraft.black_terracotta": "must terrakota",
  "block.minecraft.barrier": "ääris",
  "block.minecraft.iron_trapdoor": "raudluuk",
  "block.minecraft.hay_block": "heinapall",
  "block.minecraft.white_carpet": "valge vaip",
  "block.minecraft.orange_carpet": "oranž vaip",
  "block.minecraft.magenta_carpet": "fuksiinpunane vaip",
  "block.minecraft.light_blue_carpet": "helesinine vaip",
  "block.minecraft.yellow_carpet": "kollane vaip",
  "block.minecraft.lime_carpet": "laimiroheline vaip",
  "block.minecraft.pink_carpet": "roosa vaip",
  "block.minecraft.gray_carpet": "hall vaip",
  "block.minecraft.light_gray_carpet": "helehall vaip",
  "block.minecraft.cyan_carpet": "tsüaansinine vaip",
  "block.minecraft.purple_carpet": "lilla vaip",
  "block.minecraft.blue_carpet": "sinine vaip",
  "block.minecraft.brown_carpet": "pruun vaip",
  "block.minecraft.green_carpet": "roheline vaip",
  "block.minecraft.red_carpet": "punane vaip",
  "block.minecraft.black_carpet": "must vaip",
  "block.minecraft.terracotta": "terrakota",
  "block.minecraft.coal_block": "söeplokk",
  "block.minecraft.packed_ice": "pakitud jää",
  "block.minecraft.acacia_stairs": "akaatsiatrepp",
  "block.minecraft.dark_oak_stairs": "tumedast tammest trepp",
  "block.minecraft.slime_block": "limaplokk",
  "block.minecraft.grass_path": "mururada",
  "block.minecraft.sunflower": "päevalill",
  "block.minecraft.lilac": "sirel",
  "block.minecraft.rose_bush": "roosipõõsas",
  "block.minecraft.peony": "pojeng",
  "block.minecraft.tall_grass": "kõrge muru",
  "block.minecraft.large_fern": "kõrge sõnajalg",
  "block.minecraft.white_stained_glass": "valge värviga klaas",
  "block.minecraft.orange_stained_glass": "oranži värviga klaas",
  "block.minecraft.magenta_stained_glass": "fuksiinpunase värviga klaas",
  "block.minecraft.light_blue_stained_glass": "helesinise värviga klaas",
  "block.minecraft.yellow_stained_glass": "kollase värviga klaas",
  "block.minecraft.lime_stained_glass": "laimirohelise värviga klaas",
  "block.minecraft.pink_stained_glass": "roosa värviga klaas",
  "block.minecraft.gray_stained_glass": "halli värviga klaas",
  "block.minecraft.light_gray_stained_glass": "helehalli värviga klaas",
  "block.minecraft.cyan_stained_glass": "tsüaansinise värviga klaas",
  "block.minecraft.purple_stained_glass": "lilla värviga klaas",
  "block.minecraft.blue_stained_glass": "sinise värviga klaas",
  "block.minecraft.brown_stained_glass": "pruuni värviga klaas",
  "block.minecraft.green_stained_glass": "rohelise värviga klaas",
  "block.minecraft.red_stained_glass": "punase värviga klaas",
  "block.minecraft.black_stained_glass": "musta värviga klaas",
  "block.minecraft.white_stained_glass_pane": "valge värviga klaaspaneel",
  "block.minecraft.orange_stained_glass_pane": "oranži värviga klaaspaneel",
  "block.minecraft.magenta_stained_glass_pane": "fuksiinpunase värviga klaaspaneel",
  "block.minecraft.light_blue_stained_glass_pane": "helesinise värviga klaaspaneel",
  "block.minecraft.yellow_stained_glass_pane": "kollase värviga klaaspaneel",
  "block.minecraft.lime_stained_glass_pane": "laimirohelise värviga klaaspaneel",
  "block.minecraft.pink_stained_glass_pane": "roosa värviga klaaspaneel",
  "block.minecraft.gray_stained_glass_pane": "halli värviga klaaspaneel",
  "block.minecraft.light_gray_stained_glass_pane": "helehalli värviga klaaspaneel",
  "block.minecraft.cyan_stained_glass_pane": "tsüaansinise värviga klaaspaneel",
  "block.minecraft.purple_stained_glass_pane": "lilla värviga klaaspaneel",
  "block.minecraft.blue_stained_glass_pane": "sinise värviga klaaspaneel",
  "block.minecraft.brown_stained_glass_pane": "pruuni värviga klaaspaneel",
  "block.minecraft.green_stained_glass_pane": "rohelise värviga klaaspaneel",
  "block.minecraft.red_stained_glass_pane": "punase värviga klaaspaneel",
  "block.minecraft.black_stained_glass_pane": "musta värviga klaaspaneel",
  "block.minecraft.prismarine": "prismariin",
  "block.minecraft.prismarine_bricks": "prismariinitellised",
  "block.minecraft.dark_prismarine": "tume prismariin",
  "block.minecraft.prismarine_stairs": "prismariinitrepp",
  "block.minecraft.prismarine_brick_stairs": "prismariinitellistest trepp",
  "block.minecraft.dark_prismarine_stairs": "tumedast prismariinist trepp",
  "block.minecraft.sea_lantern": "merelatern",
  "block.minecraft.red_sandstone": "punane liivakivi",
  "block.minecraft.chiseled_red_sandstone": "peiteldatud punane liivakivi",
  "block.minecraft.cut_red_sandstone": "lõigatud punane liivakivi",
  "block.minecraft.red_sandstone_stairs": "punane liivakivitrepp",
  "block.minecraft.repeating_command_block": "kordav käsuplokk",
  "block.minecraft.chain_command_block": "ketistatud käsuplokk",
  "block.minecraft.magma_block": "magmaplokk",
  "block.minecraft.nether_wart_block": "nethertüüka plokk",
  "block.minecraft.warped_wart_block": "kentsaka tüüka plokk",
  "block.minecraft.red_nether_bricks": "punased nether-tellised",
  "block.minecraft.bone_block": "kondiplokk",
  "block.minecraft.structure_void": "struktuuritühjus",
  "block.minecraft.observer": "vaatleja",
  "block.minecraft.shulker_box": "šulkerikast",
  "block.minecraft.white_shulker_box": "valge šulkerikast",
  "block.minecraft.orange_shulker_box": "oranž šulkerikast",
  "block.minecraft.magenta_shulker_box": "fuksiinpunane šulkerikast",
  "block.minecraft.light_blue_shulker_box": "helesinine šulkerikast",
  "block.minecraft.yellow_shulker_box": "kollane šulkerikast",
  "block.minecraft.lime_shulker_box": "laimiroheline šulkerikast",
  "block.minecraft.pink_shulker_box": "roosa šulkerikast",
  "block.minecraft.gray_shulker_box": "hall šulkerikast",
  "block.minecraft.light_gray_shulker_box": "helehall šulkerikast",
  "block.minecraft.cyan_shulker_box": "tsüaansinine šulkerikast",
  "block.minecraft.purple_shulker_box": "lilla šulkerikast",
  "block.minecraft.blue_shulker_box": "sinine šulkerikast",
  "block.minecraft.brown_shulker_box": "pruun šulkerikast",
  "block.minecraft.green_shulker_box": "roheline šulkerikast",
  "block.minecraft.red_shulker_box": "punane šulkerikast",
  "block.minecraft.black_shulker_box": "must šulkerikast",
  "block.minecraft.white_glazed_terracotta": "valge glasuuritud terrakota",
  "block.minecraft.orange_glazed_terracotta": "oranž glasuuritud terrakota",
  "block.minecraft.magenta_glazed_terracotta": "fuksiinpunane glasuuritud terrakota",
  "block.minecraft.light_blue_glazed_terracotta": "helesinine glasuuritud terrakota",
  "block.minecraft.yellow_glazed_terracotta": "kollane glasuuritud terrakota",
  "block.minecraft.lime_glazed_terracotta": "laimiroheline glasuuritud terrakota",
  "block.minecraft.pink_glazed_terracotta": "roosa glasuuritud terrakota",
  "block.minecraft.gray_glazed_terracotta": "hall glasuuritud terrakota",
  "block.minecraft.light_gray_glazed_terracotta": "helehall glasuuritud terrakota",
  "block.minecraft.cyan_glazed_terracotta": "tsüaansinine glasuuritud terrakota",
  "block.minecraft.purple_glazed_terracotta": "lilla glasuuritud terrakota",
  "block.minecraft.blue_glazed_terracotta": "sinine glasuuritud terrakota",
  "block.minecraft.brown_glazed_terracotta": "pruun glasuuritud terrakota",
  "block.minecraft.green_glazed_terracotta": "roheline glasuuritud terrakota",
  "block.minecraft.red_glazed_terracotta": "punane glasuuritud terrakota",
  "block.minecraft.black_glazed_terracotta": "must glasuuritud terrakota",
  "block.minecraft.white_concrete": "valge betoon",
  "block.minecraft.orange_concrete": "oranž betoon",
  "block.minecraft.magenta_concrete": "fuksiinpunane betoon",
  "block.minecraft.light_blue_concrete": "helesinine betoon",
  "block.minecraft.yellow_concrete": "kollane betoon",
  "block.minecraft.lime_concrete": "laimiroheline betoon",
  "block.minecraft.pink_concrete": "roosa betoon",
  "block.minecraft.gray_concrete": "hall betoon",
  "block.minecraft.light_gray_concrete": "helehall betoon",
  "block.minecraft.cyan_concrete": "tsüaansinine betoon",
  "block.minecraft.purple_concrete": "lilla betoon",
  "block.minecraft.blue_concrete": "sinine betoon",
  "block.minecraft.brown_concrete": "pruun betoon",
  "block.minecraft.green_concrete": "roheline betoon",
  "block.minecraft.red_concrete": "punane betoon",
  "block.minecraft.black_concrete": "must betoon",
  "block.minecraft.white_concrete_powder": "valge betoonipulber",
  "block.minecraft.orange_concrete_powder": "oranž betoonipulber",
  "block.minecraft.magenta_concrete_powder": "fuksiinpunane betoonipulber",
  "block.minecraft.light_blue_concrete_powder": "helesinine betoonipulber",
  "block.minecraft.yellow_concrete_powder": "kollane betoonipulber",
  "block.minecraft.lime_concrete_powder": "laimiroheline betoonipulber",
  "block.minecraft.pink_concrete_powder": "roosa betoonipulber",
  "block.minecraft.gray_concrete_powder": "hall betoonipulber",
  "block.minecraft.light_gray_concrete_powder": "helehall betoonipulber",
  "block.minecraft.cyan_concrete_powder": "tsüaansinine betoonipulber",
  "block.minecraft.purple_concrete_powder": "lilla betoonipulber",
  "block.minecraft.blue_concrete_powder": "sinine betoonipulber",
  "block.minecraft.brown_concrete_powder": "pruun betoonipulber",
  "block.minecraft.green_concrete_powder": "roheline betoonipulber",
  "block.minecraft.red_concrete_powder": "punane betoonipulber",
  "block.minecraft.black_concrete_powder": "must betoonipulber",
  "block.minecraft.turtle_egg": "kilpkonnamuna",
  "block.minecraft.dead_tube_coral_block": "surnud torukoralli plokk",
  "block.minecraft.dead_brain_coral_block": "surnud ajukoralli plokk",
  "block.minecraft.dead_bubble_coral_block": "surnud mullkoralli plokk",
  "block.minecraft.dead_fire_coral_block": "surnud tulikoralli plokk",
  "block.minecraft.dead_horn_coral_block": "surnud sarvkoralli plokk",
  "block.minecraft.tube_coral_block": "torukoralli plokk",
  "block.minecraft.brain_coral_block": "ajukoralli plokk",
  "block.minecraft.bubble_coral_block": "mullkoralli plokk",
  "block.minecraft.fire_coral_block": "tulikoralli plokk",
  "block.minecraft.horn_coral_block": "sarvkoralli plokk",
  "block.minecraft.tube_coral": "torukorall",
  "block.minecraft.brain_coral": "ajukorall",
  "block.minecraft.bubble_coral": "mullkorall",
  "block.minecraft.fire_coral": "tulikorall",
  "block.minecraft.horn_coral": "sarvkorall",
  "block.minecraft.dead_brain_coral": "surnud ajukorall",
  "block.minecraft.dead_bubble_coral": "surnud mullkorall",
  "block.minecraft.dead_fire_coral": "surnud tulikorall",
  "block.minecraft.dead_horn_coral": "surnud sarvkorall",
  "block.minecraft.dead_tube_coral": "surnud torukorall",
  "block.minecraft.tube_coral_fan": "torukoralli lehvik",
  "block.minecraft.brain_coral_fan": "ajukoralli lehvik",
  "block.minecraft.bubble_coral_fan": "mullkoralli lehvik",
  "block.minecraft.fire_coral_fan": "tulikoralli lehvik",
  "block.minecraft.horn_coral_fan": "sarvkoralli lehvik",
  "block.minecraft.dead_tube_coral_fan": "surnud torukoralli lehvik",
  "block.minecraft.dead_brain_coral_fan": "surnud ajukoralli lehvik",
  "block.minecraft.dead_bubble_coral_fan": "surnud mullkoralli lehvik",
  "block.minecraft.dead_fire_coral_fan": "surnud tulikoralli lehvik",
  "block.minecraft.dead_horn_coral_fan": "surnud sarvkoralli lehvik",
  "block.minecraft.blue_ice": "sinine jää",
  "block.minecraft.conduit": "siire",
  "block.minecraft.polished_granite_stairs": "lihvitud graniidist trepp",
  "block.minecraft.smooth_red_sandstone_stairs": "siledast punasest liivakivist trepp",
  "block.minecraft.mossy_stone_brick_stairs": "sammaldunud kivitellistrepp",
  "block.minecraft.polished_diorite_stairs": "lihvitud dioriidist trepp",
  "block.minecraft.mossy_cobblestone_stairs": "sammaldunud munakivitrepp",
  "block.minecraft.end_stone_brick_stairs": "endikivi tellistrepp",
  "block.minecraft.stone_stairs": "kivitrepp",
  "block.minecraft.smooth_sandstone_stairs": "siledast liivakivist trepp",
  "block.minecraft.smooth_quartz_stairs": "siledast kvartsist trepp",
  "block.minecraft.granite_stairs": "graniit-trepp",
  "block.minecraft.andesite_stairs": "andesiit-trepp",
  "block.minecraft.red_nether_brick_stairs": "punane nether-tellistrepp",
  "block.minecraft.polished_andesite_stairs": "lihvitud andesiidist trepp",
  "block.minecraft.diorite_stairs": "dioriit-trepp",
  "block.minecraft.polished_granite_slab": "lihvitud graniidist plaat",
  "block.minecraft.smooth_red_sandstone_slab": "siledast punasest liivakivist plaat",
  "block.minecraft.mossy_stone_brick_slab": "sammaldunud kivitellisplaat",
  "block.minecraft.polished_diorite_slab": "lihvitud dioriidist plaat",
  "block.minecraft.mossy_cobblestone_slab": "sammaldunud munakiviplaat",
  "block.minecraft.end_stone_brick_slab": "endikivi tellisplaat",
  "block.minecraft.smooth_sandstone_slab": "siledast liivakivist plaat",
  "block.minecraft.smooth_quartz_slab": "siledast kvartsist plaat",
  "block.minecraft.granite_slab": "graniitplaat",
  "block.minecraft.andesite_slab": "andesiitplaat",
  "block.minecraft.red_nether_brick_slab": "punane nether-tellisplaat",
  "block.minecraft.polished_andesite_slab": "lihvitud andesiidist plaat",
  "block.minecraft.diorite_slab": "dioriitplaat",
  "block.minecraft.scaffolding": "telling",
  "block.minecraft.iron_door": "rauduks",
  "block.minecraft.oak_door": "tammest uks",
  "block.minecraft.spruce_door": "kuusest uks",
  "block.minecraft.birch_door": "kasest uks",
  "block.minecraft.jungle_door": "džunglipuidust uks",
  "block.minecraft.acacia_door": "akaatsiast uks",
  "block.minecraft.dark_oak_door": "tumedast tammest uks",
  "block.minecraft.crimson_door": "karmiinpunane uks",
  "block.minecraft.warped_door": "kentsakas uks",
  "block.minecraft.repeater": "redstone'i järgur",
  "block.minecraft.comparator": "redstone'i komparaator",
  "block.minecraft.structure_block": "struktuuriplokk",
  "block.minecraft.jigsaw": "pusleplokk",
  "item.minecraft.turtle_helmet": "kilpkonna kilp□□olles peas:□+2 rüüpunkti",
  "item.minecraft.scute": "soomus",
  "item.minecraft.iron_shovel": "raudlabidas□□olles peamises käes:□+3.5 löögikahju□-3 ründekiirus",
  "item.minecraft.iron_pickaxe": "raudkirka□□olles peamises käes:□+3 löögikahju□-2.8 ründekiirus",
  "item.minecraft.iron_axe": "raudkirves□□olles peamises käes:□+8 löögikahju□-3.1 ründekiirus",
  "item.minecraft.flint_and_steel": "tuleraud",
  "item.minecraft.apple": "õun",
  "item.minecraft.bow": "vibu",
  "item.minecraft.arrow": "nool",
  "item.minecraft.coal": "süsi",
  "item.minecraft.charcoal": "puusüsi",
  "item.minecraft.diamond": "teemant",
  "item.minecraft.iron_ingot": "rauakang",
  "item.minecraft.gold_ingot": "kullakang",
  "item.minecraft.netherite_ingot": "netheriidikang",
  "item.minecraft.netherite_scrap": "netheriidijäägid",
  "item.minecraft.iron_sword": "raudmõõk□□olles peamises käes:□+5 löögikahju□-2.4 ründekiirus",
  "item.minecraft.wooden_sword": "puitmõõk□□olles peamises käes:□+3 löögikahju□-2.4 ründekiirus",
  "item.minecraft.wooden_shovel": "puitlabidas□□olles peamises käes:□+1.5 löögikahju□-3 ründekiirus",
  "item.minecraft.wooden_pickaxe": "puitkirka□□olles peamises käes:□+1 löögikahju□-2.8 ründekiirus",
  "item.minecraft.wooden_axe": "puitkirves□□olles peamises käes:□+6 löögikahju□-3.2 ründekiirus",
  "item.minecraft.stone_sword": "kivimõõk□□olles peamises käes:□+4 löögikahju□-2.4 ründekiirus",
  "item.minecraft.stone_shovel": "kivilabidas□□olles peamises käes:□+2.5 löögikahju□-3 ründekiirus",
  "item.minecraft.stone_pickaxe": "kivikirka□□olles peamises käes:□+2 löögikahju□-2.8 ründekiirus",
  "item.minecraft.stone_axe": "kivikirves□□olles peamises käes:□+8 löögikahju□-3.2 ründekiirus",
  "item.minecraft.diamond_sword": "teemantmõõk□□olles peamises käes:□+6 löögikahju□-2.4 ründekiirus",
  "item.minecraft.diamond_shovel": "teemantlabidas□□olles peamises käes:□+4.5 löögikahju□-3 ründekiirus",
  "item.minecraft.diamond_pickaxe": "teemantkirka□□olles peamises käes:□+4 löögikahju□-2.8 ründekiirus",
  "item.minecraft.diamond_axe": "teemantkirves□□olles peamises käes:□+8 löögikahju□-3 ründekiirus",
  "item.minecraft.stick": "pulk",
  "item.minecraft.bowl": "kauss",
  "item.minecraft.mushroom_stew": "seenehautis",
  "item.minecraft.golden_sword": "kuldmõõk□□olles peamises käes:□+3 löögikahju□-2.4 ründekiirus",
  "item.minecraft.golden_shovel": "kuldlabidas□□olles peamises käes:□+1.5 löögikahju□-3 ründekiirus",
  "item.minecraft.golden_pickaxe": "kuldkirka□□olles peamises käes:□+1 löögikahju□-2.8 ründekiirus",
  "item.minecraft.golden_axe": "kuldkirves□□olles peamises käes:□+6 löögikahju□-3 ründekiirus",
  "item.minecraft.netherite_sword": "netheriitmõõk□□olles peamises käes:□+7 löögikahju□-2.4 ründekiirus",
  "item.minecraft.netherite_shovel": "netheriitlabidas□□olles peamises käes:□+5.5 löögikahju□-3 ründekiirus",
  "item.minecraft.netherite_pickaxe": "netheriitkirka□□olles peamises käes:□+5 löögikahju□-2.8 ründekiirus",
  "item.minecraft.netherite_axe": "netheriitkirves□□olles peamises käes:□+9 löögikahju□-3 ründekiirus",
  "item.minecraft.string": "nöör",
  "item.minecraft.feather": "sulg",
  "item.minecraft.gunpowder": "püssirohi",
  "item.minecraft.wooden_hoe": "puitkõblas□□olles peamises käes:□-3 ründekiirus",
  "item.minecraft.stone_hoe": "kivikõblas□□olles peamises käes:□-2 ründekiirus",
  "item.minecraft.iron_hoe": "raudkõblas□□olles peamises käes:□-1 ründekiirus",
  "item.minecraft.diamond_hoe": "teemantkõblas□□olles peamises käes:",
  "item.minecraft.golden_hoe": "kuldkõblas□□olles peamises käes:□-3 ründekiirus",
  "item.minecraft.netherite_hoe": "netheriitkõblas□□olles peamises käes:",
  "item.minecraft.wheat_seeds": "nisuseemned",
  "item.minecraft.wheat": "nisu",
  "item.minecraft.bread": "leib",
  "item.minecraft.leather_helmet": "nahkmüts□□olles peas:□+1 rüüpunkti",
  "item.minecraft.leather_chestplate": "nahktuunika□□olles seljas:□+3 rüüpunkti",
  "item.minecraft.leather_leggings": "nahkpüksid□□olles säärtel:□+2 rüüpunkti",
  "item.minecraft.leather_boots": "nahksaapad□□olles jalas:□+1 rüüpunkti",
  "item.minecraft.chainmail_helmet": "rõngaskiiver□□olles peas:□+2 rüüpunkti",
  "item.minecraft.chainmail_chestplate": "rõngasrinnaplaat□□olles seljas:□+5 rüüpunkti",
  "item.minecraft.chainmail_leggings": "rõngassäärised□□olles säärtel:□+4 rüüpunkti",
  "item.minecraft.chainmail_boots": "rõngassaapad□□olles jalas:□+1 rüüpunkti",
  "item.minecraft.iron_helmet": "raudkiiver□□olles peas:□+2 rüüpunkti",
  "item.minecraft.iron_chestplate": "raudrinnaplaat□□olles seljas:□+6 rüüpunkti",
  "item.minecraft.iron_leggings": "raudsäärised□□olles säärtel:□+5 rüüpunkti",
  "item.minecraft.iron_boots": "raudsaapad□□olles jalas:□+2 rüüpunkti",
  "item.minecraft.diamond_helmet": "teemantkiiver□□olles peas:□+3 rüüpunkti□+2 rüütugevust",
  "item.minecraft.diamond_chestplate": "teemantrinnaplaat□□olles seljas:□+8 rüüpunkti□+2 rüütugevust",
  "item.minecraft.diamond_leggings": "teemantsäärised□□olles säärtel:□+6 rüüpunkti□+2 rüütugevust",
  "item.minecraft.diamond_boots": "teemantsaapad□□olles jalas:□+3 rüüpunkti□+2 rüütugevust",
  "item.minecraft.golden_helmet": "kuldkiiver□□olles peas:□+2 rüüpunkti",
  "item.minecraft.golden_chestplate": "kuldrinnaplaat□□olles seljas:□+5 rüüpunkti",
  "item.minecraft.golden_leggings": "kuldsäärised□□olles säärtel:□+3 rüüpunkti",
  "item.minecraft.golden_boots": "kuldsaapad□□olles jalas:□+1 rüüpunkti",
  "item.minecraft.netherite_helmet": "netheriitkiiver□□olles peas:□+3 rüüpunkti□+3 rüütugevust□+1 tagasilöögi vastupanu",
  "item.minecraft.netherite_chestplate": "netheriitrinnaplaat□□olles seljas:□+8 rüüpunkti□+3 rüütugevust□+1 tagasilöögi vastupanu",
  "item.minecraft.netherite_leggings": "netheriitsäärised□□olles säärtel:□+6 rüüpunkti□+3 rüütugevust□+1 tagasilöögi vastupanu",
  "item.minecraft.netherite_boots": "netheriitsaapad□□olles jalas:□+3 rüüpunkti□+3 rüütugevust□+1 tagasilöögi vastupanu",
  "item.minecraft.flint": "tulekivi",
  "item.minecraft.porkchop": "toores sealiha",
  "item.minecraft.cooked_porkchop": "küpsetatud sealiha",
  "item.minecraft.painting": "maal",
  "item.minecraft.golden_apple": "kuldõun",
  "item.minecraft.enchanted_golden_apple": "loitsitud kuldõun",
  "block.minecraft.oak_sign": "tammest silt",
  "block.minecraft.spruce_sign": "kuusest silt",
  "block.minecraft.birch_sign": "kasest silt",
  "block.minecraft.jungle_sign": "džunglipuidust silt",
  "block.minecraft.acacia_sign": "akaatsiast silt",
  "block.minecraft.dark_oak_sign": "tumedast tammest silt",
  "block.minecraft.crimson_sign": "karmiinpunane silt",
  "block.minecraft.warped_sign": "kentsakas silt",
  "item.minecraft.bucket": "ämber",
  "item.minecraft.water_bucket": "veeämber",
  "item.minecraft.lava_bucket": "laavaämber",
  "item.minecraft.minecart": "kaevanduskäru",
  "item.minecraft.saddle": "sadul",
  "item.minecraft.redstone": "redstone-tolm",
  "item.minecraft.snowball": "lumepall",
  "item.minecraft.oak_boat": "tammest paat",
  "item.minecraft.leather": "nahk",
  "item.minecraft.milk_bucket": "piimaämber",
  "item.minecraft.pufferfish_bucket": "kerakalaämber",
  "item.minecraft.salmon_bucket": "lõheämber",
  "item.minecraft.cod_bucket": "tursaämber",
  "item.minecraft.tropical_fish_bucket": "troopilise kala ämber",
  "item.minecraft.brick": "tellis",
  "item.minecraft.clay_ball": "savipall",
  "block.minecraft.dried_kelp_block": "kuivatatud vetikaplokk",
  "item.minecraft.paper": "paber",
  "item.minecraft.book": "raamat",
  "item.minecraft.slime_ball": "limapall",
  "item.minecraft.chest_minecart": "kirstuga kaevanduskäru",
  "item.minecraft.furnace_minecart": "ahjuga kaevanduskäru",
  "item.minecraft.egg": "muna",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "õng",
  "item.minecraft.clock": "kell",
  "item.minecraft.glowstone_dust": "hõõgkivi tolm",
  "item.minecraft.cod": "toores tursk",
  "item.minecraft.salmon": "toores lõhe",
  "item.minecraft.tropical_fish": "troopiline kala",
  "item.minecraft.pufferfish": "kerakala",
  "item.minecraft.cooked_cod": "küpsetatud tursk",
  "item.minecraft.cooked_salmon": "küpsetatud lõhe",
  "item.minecraft.ink_sac": "tindikott",
  "item.minecraft.red_dye": "punane värvaine",
  "item.minecraft.green_dye": "roheline värvaine",
  "item.minecraft.cocoa_beans": "kakaooad",
  "item.minecraft.lapis_lazuli": "lasuriit",
  "item.minecraft.purple_dye": "lilla värvaine",
  "item.minecraft.cyan_dye": "tsüaansinine värvaine",
  "item.minecraft.light_gray_dye": "helehall värvaine",
  "item.minecraft.gray_dye": "hall värvaine",
  "item.minecraft.pink_dye": "roosa värvaine",
  "item.minecraft.lime_dye": "laimiroheline värvaine",
  "item.minecraft.yellow_dye": "kollane värvaine",
  "item.minecraft.light_blue_dye": "helesinine värvaine",
  "item.minecraft.magenta_dye": "fuksiinpunane värvaine",
  "item.minecraft.orange_dye": "oranž värvaine",
  "item.minecraft.bone_meal": "kondijahu",
  "item.minecraft.blue_dye": "sinine värvaine",
  "item.minecraft.brown_dye": "pruun värvaine",
  "item.minecraft.black_dye": "must värvaine",
  "item.minecraft.white_dye": "valge värvaine",
  "item.minecraft.bone": "kont",
  "item.minecraft.sugar": "suhkur",
  "block.minecraft.cake": "kook",
  "block.minecraft.white_bed": "valge voodi",
  "block.minecraft.orange_bed": "oranž voodi",
  "block.minecraft.magenta_bed": "fuksiinpunane voodi",
  "block.minecraft.light_blue_bed": "helesinine voodi",
  "block.minecraft.yellow_bed": "kollane voodi",
  "block.minecraft.lime_bed": "laimiroheline voodi",
  "block.minecraft.pink_bed": "roosa voodi",
  "block.minecraft.gray_bed": "hall voodi",
  "block.minecraft.light_gray_bed": "helehall voodi",
  "block.minecraft.cyan_bed": "tsüaansinine voodi",
  "block.minecraft.purple_bed": "lilla voodi",
  "block.minecraft.blue_bed": "sinine voodi",
  "block.minecraft.brown_bed": "pruun voodi",
  "block.minecraft.green_bed": "roheline voodi",
  "block.minecraft.red_bed": "punane voodi",
  "block.minecraft.black_bed": "must voodi",
  "item.minecraft.cookie": "küpsis",
  "item.minecraft.filled_map": "kaart□#0",
  "item.minecraft.shears": "käärid",
  "item.minecraft.melon_slice": "meloniviil",
  "item.minecraft.dried_kelp": "kuivatatud vetikas",
  "item.minecraft.pumpkin_seeds": "kõrvitsaseemned",
  "item.minecraft.melon_seeds": "meloniseemned",
  "item.minecraft.beef": "toores veiseliha",
  "item.minecraft.cooked_beef": "küpsetatud veiseliha",
  "item.minecraft.chicken": "toores kana",
  "item.minecraft.cooked_chicken": "küpsetatud kana",
  "item.minecraft.rotten_flesh": "roiskunud liha",
  "item.minecraft.ender_pearl": "enderipärl",
  "item.minecraft.blaze_rod": "lõõmavarras",
  "item.minecraft.ghast_tear": "ghasti pisar",
  "item.minecraft.gold_nugget": "kullavaland",
  "item.minecraft.nether_wart": "nethertüügas",
  "item.minecraft.potion": "meisterdamatu võlujook□pole mõju",
  "item.minecraft.glass_bottle": "klaaspudel",
  "item.minecraft.spider_eye": "ämblikusilm",
  "item.minecraft.fermented_spider_eye": "käärinud ämblikusilm",
  "item.minecraft.blaze_powder": "lõõmapuuder",
  "item.minecraft.magma_cream": "magmakreem",
  "block.minecraft.brewing_stand": "pruulimisalus",
  "block.minecraft.cauldron": "pada",
  "item.minecraft.ender_eye": "enderi silm",
  "item.minecraft.glistering_melon_slice": "sätendav meloniviil",
  "item.minecraft.bat_spawn_egg": "nahkhiire sünnimuna",
  "item.minecraft.bee_spawn_egg": "mesilase sünnimuna",
  "item.minecraft.blaze_spawn_egg": "lõõma sünnimuna",
  "item.minecraft.cat_spawn_egg": "kassi sünnimuna",
  "item.minecraft.cave_spider_spawn_egg": "koopaämbliku sünnimuna",
  "item.minecraft.chicken_spawn_egg": "kana sünnimuna",
  "item.minecraft.cod_spawn_egg": "tursa sünnimuna",
  "item.minecraft.cow_spawn_egg": "lehma sünnimuna",
  "item.minecraft.creeper_spawn_egg": "creeperi sünnimuna",
  "item.minecraft.dolphin_spawn_egg": "delfiini sünnimuna",
  "item.minecraft.donkey_spawn_egg": "eesli sünnimuna",
  "item.minecraft.drowned_spawn_egg": "uppunu sünnimuna",
  "item.minecraft.elder_guardian_spawn_egg": "vanemkaitsja sünnimuna",
  "item.minecraft.enderman_spawn_egg": "endermani sünnimuna",
  "item.minecraft.endermite_spawn_egg": "endermiidi sünnimuna",
  "item.minecraft.evoker_spawn_egg": "ilmutaja sünnimuna",
  "item.minecraft.fox_spawn_egg": "rebase sünnimuna",
  "item.minecraft.ghast_spawn_egg": "ghasti sünnimuna",
  "item.minecraft.guardian_spawn_egg": "kaitsja sünnimuna",
  "item.minecraft.hoglin_spawn_egg": "hoglini sünnimuna",
  "item.minecraft.horse_spawn_egg": "hobuse sünnimuna",
  "item.minecraft.husk_spawn_egg": "kuiviku sünnimuna",
  "item.minecraft.llama_spawn_egg": "laama sünnimuna",
  "item.minecraft.magma_cube_spawn_egg": "magmakuubi sünnimuna",
  "item.minecraft.mooshroom_spawn_egg": "mooshroomi sünnimuna",
  "item.minecraft.mule_spawn_egg": "muula sünnimuna",
  "item.minecraft.ocelot_spawn_egg": "otseloti sünnimuna",
  "item.minecraft.panda_spawn_egg": "panda sünnimuna",
  "item.minecraft.parrot_spawn_egg": "papagoi sünnimuna",
  "item.minecraft.phantom_spawn_egg": "fantoomi sünnimuna",
  "item.minecraft.pig_spawn_egg": "sea sünnimuna",
  "item.minecraft.piglin_spawn_egg": "piglini sünnimuna",
  "item.minecraft.pillager_spawn_egg": "rüüstaja sünnimuna",
  "item.minecraft.polar_bear_spawn_egg": "jääkaru sünnimuna",
  "item.minecraft.pufferfish_spawn_egg": "kerakala sünnimuna",
  "item.minecraft.rabbit_spawn_egg": "küüliku sünnimuna",
  "item.minecraft.ravager_spawn_egg": "laastaja sünnimuna",
  "item.minecraft.salmon_spawn_egg": "lõhe sünnimuna",
  "item.minecraft.sheep_spawn_egg": "lamba sünnimuna",
  "item.minecraft.shulker_spawn_egg": "šulkeri sünnimuna",
  "item.minecraft.silverfish_spawn_egg": "majasoomuka sünnimuna",
  "item.minecraft.skeleton_spawn_egg": "luukere sünnimuna",
  "item.minecraft.skeleton_horse_spawn_egg": "luukerehobuse sünnimuna",
  "item.minecraft.slime_spawn_egg": "limuse sünnimuna",
  "item.minecraft.spider_spawn_egg": "ämbliku sünnimuna",
  "item.minecraft.squid_spawn_egg": "kalmaari sünnimuna",
  "item.minecraft.stray_spawn_egg": "eksleja sünnimuna",
  "item.minecraft.strider_spawn_egg": "tatsaja sünnimuna",
  "item.minecraft.trader_llama_spawn_egg": "kaupleja laama sünnimuna",
  "item.minecraft.tropical_fish_spawn_egg": "troopilise kala sünnimuna",
  "item.minecraft.turtle_spawn_egg": "kilpkonna sünnimuna",
  "item.minecraft.vex_spawn_egg": "pahandaja sünnimuna",
  "item.minecraft.villager_spawn_egg": "külaelaniku sünnimuna",
  "item.minecraft.vindicator_spawn_egg": "õigustaja sünnimuna",
  "item.minecraft.wandering_trader_spawn_egg": "uitava kaupleja sünnimuna",
  "item.minecraft.witch_spawn_egg": "nõia sünnimuna",
  "item.minecraft.wither_skeleton_spawn_egg": "wither-luukere sünnimuna",
  "item.minecraft.wolf_spawn_egg": "hundi sünnimuna",
  "item.minecraft.zoglin_spawn_egg": "zoglini sünnimuna",
  "item.minecraft.zombie_spawn_egg": "zombi sünnimuna",
  "item.minecraft.zombie_horse_spawn_egg": "zombihobuse sünnimuna",
  "item.minecraft.zombie_villager_spawn_egg": "zombi-külaelaniku sünnimuna",
  "item.minecraft.zombified_piglin_spawn_egg": "zombistunud piglini sünnimuna",
  "item.minecraft.experience_bottle": "loitsimispudel",
  "item.minecraft.fire_charge": "tulelaeng",
  "item.minecraft.writable_book": "raamat ja kirjasulg",
  "item.minecraft.written_book": "kirjutatud raamat",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "esemeraam",
  "block.minecraft.flower_pot": "lillepott",
  "item.minecraft.carrot": "porgand",
  "item.minecraft.potato": "kartul",
  "item.minecraft.baked_potato": "ahjukartul",
  "item.minecraft.poisonous_potato": "mürgine kartul",
  "item.minecraft.map": "tühi kaart",
  "item.minecraft.golden_carrot": "kuldne porgand",
  "block.minecraft.skeleton_skull": "luukere pealuu",
  "block.minecraft.wither_skeleton_skull": "wither-luukere pealuu",
  "block.minecraft.player_head": "mängija pea",
  "block.minecraft.zombie_head": "zombi pea",
  "block.minecraft.creeper_head": "creeperi pea",
  "block.minecraft.dragon_head": "draakoni pea",
  "item.minecraft.carrot_on_a_stick": "porgand pulga otsas",
  "item.minecraft.warped_fungus_on_a_stick": "kentsakas seen pulga otsas",
  "item.minecraft.nether_star": "netheritäht",
  "item.minecraft.pumpkin_pie": "kõrvitsapirukas",
  "item.minecraft.firework_rocket": "ilutulestiku rakett",
  "item.minecraft.firework_star": "ilutulestiku täht",
  "item.minecraft.enchanted_book": "loitsitud raamat",
  "item.minecraft.nether_brick": "nether-tellis",
  "item.minecraft.quartz": "netheri kvarts",
  "item.minecraft.tnt_minecart": "dünamiidiga kaevanduskäru",
  "item.minecraft.hopper_minecart": "püüdjaga kaevanduskäru",
  "item.minecraft.prismarine_shard": "prismariinikild",
  "item.minecraft.prismarine_crystals": "prismariinikristallid",
  "item.minecraft.rabbit": "toores küülik",
  "item.minecraft.cooked_rabbit": "küpsetatud küülik",
  "item.minecraft.rabbit_stew": "küülikuhautis",
  "item.minecraft.rabbit_foot": "küüliku jalg",
  "item.minecraft.rabbit_hide": "küülikunahk",
  "item.minecraft.armor_stand": "rüüalus",
  "item.minecraft.iron_horse_armor": "hobuse raudrüü",
  "item.minecraft.golden_horse_armor": "hobuse kuldrüü",
  "item.minecraft.diamond_horse_armor": "hobuse teemantrüü",
  "item.minecraft.leather_horse_armor": "hobuse nahkrüü",
  "item.minecraft.lead": "köis",
  "item.minecraft.name_tag": "nimesilt",
  "item.minecraft.command_block_minecart": "käsuplokiga kaevanduskäru",
  "item.minecraft.mutton": "toores lambaliha",
  "item.minecraft.cooked_mutton": "küpsetatud lambaliha",
  "block.minecraft.white_banner": "valge plakat",
  "block.minecraft.orange_banner": "oranž plakat",
  "block.minecraft.magenta_banner": "fuksiinpunane plakat",
  "block.minecraft.light_blue_banner": "helesinine plakat",
  "block.minecraft.yellow_banner": "kollane plakat",
  "block.minecraft.lime_banner": "laimiroheline plakat",
  "block.minecraft.pink_banner": "roosa plakat",
  "block.minecraft.gray_banner": "hall plakat",
  "block.minecraft.light_gray_banner": "helehall plakat",
  "block.minecraft.cyan_banner": "tsüaansinine plakat",
  "block.minecraft.purple_banner": "lilla plakat",
  "block.minecraft.blue_banner": "sinine plakat",
  "block.minecraft.brown_banner": "pruun plakat",
  "block.minecraft.green_banner": "roheline plakat",
  "block.minecraft.red_banner": "punane plakat",
  "block.minecraft.black_banner": "must plakat",
  "item.minecraft.end_crystal": "endikristall",
  "item.minecraft.chorus_fruit": "koorivili",
  "item.minecraft.popped_chorus_fruit": "paisunud koorivili",
  "item.minecraft.beetroot": "peet",
  "item.minecraft.beetroot_seeds": "peediseemned",
  "item.minecraft.beetroot_soup": "peedisupp",
  "item.minecraft.dragon_breath": "draakoni hingeõhk",
  "item.minecraft.splash_potion": "pritsitav meisterdamatu võlujook□pole mõju",
  "item.minecraft.spectral_arrow": "spektraalne nool",
  "item.minecraft.tipped_arrow": "meisterdamatu mõjuga nool□pole mõju",
  "item.minecraft.lingering_potion": "pikaldane meisterdamatu võlujook□pole mõju",
  "item.minecraft.shield": "kilp",
  "item.minecraft.elytra": "kattetiivad",
  "item.minecraft.spruce_boat": "kuusest paat",
  "item.minecraft.birch_boat": "kasest paat",
  "item.minecraft.jungle_boat": "džunglipuidust paat",
  "item.minecraft.acacia_boat": "akaatsiast paat",
  "item.minecraft.dark_oak_boat": "tumedast tammest paat",
  "item.minecraft.totem_of_undying": "ebasurma tootem",
  "item.minecraft.shulker_shell": "šulkeri kest",
  "item.minecraft.iron_nugget": "rauavaland",
  "item.minecraft.knowledge_book": "teadmiste raamat",
  "item.minecraft.debug_stick": "siluripulk",
  "item.minecraft.music_disc_13": "muusikaplaat□c418 - 13",
  "item.minecraft.music_disc_cat": "muusikaplaat□c418 - cat",
  "item.minecraft.music_disc_blocks": "muusikaplaat□c418 - blocks",
  "item.minecraft.music_disc_chirp": "muusikaplaat□c418 - chirp",
  "item.minecraft.music_disc_far": "muusikaplaat□c418 - far",
  "item.minecraft.music_disc_mall": "muusikaplaat□c418 - mall",
  "item.minecraft.music_disc_mellohi": "muusikaplaat□c418 - mellohi",
  "item.minecraft.music_disc_stal": "muusikaplaat□c418 - stal",
  "item.minecraft.music_disc_strad": "muusikaplaat□c418 - strad",
  "item.minecraft.music_disc_ward": "muusikaplaat□c418 - ward",
  "item.minecraft.music_disc_11": "muusikaplaat□c418 - 11",
  "item.minecraft.music_disc_wait": "muusikaplaat□c418 - wait",
  "item.minecraft.music_disc_pigstep": "muusikaplaat□lena raine - pigstep",
  "item.minecraft.trident": "kolmhark□□olles peamises käes:□+8 löögikahju□-2.9 ründekiirus",
  "item.minecraft.phantom_membrane": "fantoomi membraan",
  "item.minecraft.nautilus_shell": "laevukese karp",
  "item.minecraft.heart_of_the_sea": "mere süda",
  "item.minecraft.crossbow": "amb",
  "item.minecraft.suspicious_stew": "kahtlane hautis",
  "block.minecraft.loom": "kangasteljed",
  "item.minecraft.flower_banner_pattern": "plakatimuster□lille embleem",
  "item.minecraft.creeper_banner_pattern": "plakatimuster□creeperi embleem",
  "item.minecraft.skull_banner_pattern": "plakatimuster□pealuu embleem",
  "item.minecraft.mojang_banner_pattern": "plakatimuster□asi",
  "item.minecraft.globe_banner_pattern": "plakatimuster□gloobus",
  "item.minecraft.piglin_banner_pattern": "plakatimuster□kärss",
  "block.minecraft.composter": "komposter",
  "block.minecraft.barrel": "tünn",
  "block.minecraft.smoker": "suitsuahi",
  "block.minecraft.blast_furnace": "kõrgahi",
  "block.minecraft.cartography_table": "kartograafialaud",
  "block.minecraft.fletching_table": "noolekinnituslaud",
  "block.minecraft.grindstone": "käiakivi",
  "block.minecraft.lectern": "kõnepult",
  "block.minecraft.smithing_table": "sepistuslaud",
  "block.minecraft.stonecutter": "kivilõikur",
  "block.minecraft.bell": "kelluke",
  "block.minecraft.lantern": "latern",
  "block.minecraft.soul_lantern": "hingelatern",
  "item.minecraft.sweet_berries": "magusad marjad",
  "block.minecraft.campfire": "lõkketuli",
  "block.minecraft.soul_campfire": "hinge lõkketuli",
  "block.minecraft.shroomlight": "seenevalgus",
  "item.minecraft.honeycomb": "meekärg",
  "block.minecraft.bee_nest": "mesilaspesa",
  "block.minecraft.beehive": "mesitaru",
  "item.minecraft.honey_bottle": "meepudel",
  "block.minecraft.honey_block": "meeplokk",
  "block.minecraft.honeycomb_block": "meekärjeplokk",
  "block.minecraft.lodestone": "teekivi",
  "block.minecraft.netherite_block": "netheriitplokk",
  "block.minecraft.ancient_debris": "antiikrusud",
  "block.minecraft.target": "märklaud",
  "block.minecraft.crying_obsidian": "nuttev obsidiaan",
  "block.minecraft.blackstone": "mustkivi",
  "block.minecraft.blackstone_slab": "mustkiviplaat",
  "block.minecraft.blackstone_stairs": "mustkivitrepp",
  "block.minecraft.gilded_blackstone": "kullatud mustkivi",
  "block.minecraft.polished_blackstone": "lihvitud mustkivi",
  "block.minecraft.polished_blackstone_slab": "lihvitud mustkivist plaat",
  "block.minecraft.polished_blackstone_stairs": "lihvitud mustkivist trepp",
  "block.minecraft.chiseled_polished_blackstone": "peiteldatud lihvitud mustkivi",
  "block.minecraft.polished_blackstone_bricks": "lihvitud mustkivi tellised",
  "block.minecraft.polished_blackstone_brick_slab": "lihvitud mustkivi tellistest plaat",
  "block.minecraft.polished_blackstone_brick_stairs": "lihvitud mustkivi tellistest trepp",
  "block.minecraft.cracked_polished_blackstone_bricks": "pragunenud lihvitud mustkivi tellised",
  "block.minecraft.respawn_anchor": "taastekkeankur",
}
export const et_ee = items; 
